import { formatLensCreditDollars } from '@/Util/LensCredit'

export default ({ href = '/newest/luxury-lens-credits', className = '', upTo = 250 }) => {
    return (
        <a href={href} className={`house-of-prada-lens-credits-strip ${className}`.trim()}>
            <span className="house-of-prada-lens-credits-strip__logos">
                <img
                    src="/img/prada-lens-credits-july-2026.svg"
                    alt="Prada"
                    className="house-of-prada-lens-credits-strip__prada"
                />
                <img
                    src="/img/miu-miu-lens-credits-july-2026.svg"
                    alt="Miu Miu"
                    className="house-of-prada-lens-credits-strip__miu"
                />
                <img
                    src="/img/oliver-peoples-lens-credits-july-2026.svg"
                    alt="Oliver Peoples"
                    className="house-of-prada-lens-credits-strip__oliver"
                />
            </span>
            <span className="house-of-prada-lens-credits-strip__content">
                <span className="house-of-prada-lens-credits-strip__copy">
                    <span className="house-of-prada-lens-credits-strip__copy-prefix">Up to</span>
                    <strong className="house-of-prada-lens-credits-strip__amount">{formatLensCreditDollars(upTo)}</strong>
                    <span className="house-of-prada-lens-credits-strip__copy-suffix">in Lens Credits</span>
                </span>
                <span className="house-of-prada-lens-credits-strip__cta">Shop Now</span>
            </span>
        </a>
    )
}
